import React from "react";

type DevAccessGateDialogProps = {
  children: React.ReactNode;
};

export function DevAccessGateDialog({ children }: DevAccessGateDialogProps) {
  return <>{children}</>;
}
